// app/stores/localesStore.ts

import { defineStore } from "pinia";
import { useCompetitionStore } from "~/stores/competitionStore";
import { usePosts } from "~/composables/posts";

export const useLocalesStore = defineStore("localesStore", () => {
  const { getAllRegionsAvailableNewsLocales } = usePosts();

  const allRegionsAvailableNewsLocales = ref<{ [key: string]: string[] }>();
  const currentRegionAvailableNewsLocales = ref<string[] | undefined>();

  const findCurrentRegionLocales = () => {
    const pinia = usePinia();
    const competitionStore = useCompetitionStore(pinia);
    if (!!allRegionsAvailableNewsLocales.value && competitionStore.region?.id) {
      const stringRegionId = competitionStore.region.id.toString();
      return allRegionsAvailableNewsLocales.value[stringRegionId];
    } else {
      return undefined;
    }
  };

  const initializeLocalesStore = async () => {
    allRegionsAvailableNewsLocales.value = await getAllRegionsAvailableNewsLocales();
    currentRegionAvailableNewsLocales.value = findCurrentRegionLocales();
  };

  return {
    currentRegionAvailableNewsLocales,
    allRegionsAvailableNewsLocales,
    initializeLocalesStore,
  };
});
